// import { Heading } from 'components/new-landing-page/Heading';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css';

// const HeroTitleText = [
//     {
//         text: "Boost Revenue"
//     }, {
//         text: "Enhance Admissions"
//     }, {
//         text: "Optimize Operations"
//     }
// ]

// const HeroTitle = () => {
//     return (
//         <Carousel className="h-[100px]" autoPlay showArrows={false} infiniteLoop axis="vertical" showIndicators={false} showStatus={false} showThumbs={false}>
//             {HeroTitleText?.map((item, index) => <Heading
//                 key={"asljdbkjasdbkasjbdasd" + index}
//                 size="headinglg2"
//                 as="h2"
//                 className="!font-schibstedgrotesk text-[40px] font-semibold capitalize tracking-[-2.16px] !text-indigo-a700 md:text-[48px]"
//             >
//                 {item?.text}
//             </Heading>)}
//         </Carousel>
//     );
// }

// export default HeroTitle;

import styled, { keyframes } from 'styled-components';
import { Heading } from 'components/new-landing-page/Heading';

// Define the type for the props
interface HeightProps {
    itemHeight: number;
}

const swipeAnimation = (itemHeight: number) => keyframes`
  0% { margin-top: ${itemHeight}px; }
  5% { margin-top: 0; }
  33% { margin-top: 0; }
  38% { margin-top: -${itemHeight}px; }
  66% { margin-top: -${itemHeight}px; }
  71% { margin-top: -${itemHeight * 2}px; }
  99.99% { margin-top: -${itemHeight * 2}px; }
  100% { margin-top: ${itemHeight}px; }
`;

const WordCarouselContainer = styled.div`
  display: flex;
  justify-items: center;
  align-items: center;
  margin: 0;
`;

const Div = styled.div<HeightProps>`
  overflow: hidden;
  position: relative;
  height: ${({ itemHeight }) => itemHeight}px;
`;

const Ul = styled.ul<HeightProps>`
  padding: 0;
  margin: 0;
  list-style: none;
  position: relative;
  animation: ${({ itemHeight }) => swipeAnimation(itemHeight)} 8s ease-in-out infinite;
`;

const Li = styled.li<HeightProps>`
  padding: 0 10px;
  height: ${({ itemHeight }) => itemHeight}px;
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
`;

const HeroTitle = ({ height = 60 }: { height?: number }) => {
    return (
        <WordCarouselContainer>
            <Div itemHeight={height}>
                <Ul itemHeight={height}>
                    <Li itemHeight={height}>
                        <Heading
                            size="headinglg2"
                            as="h2"
                            className="text-center !font-schibstedgrotesk text-[40px] font-semibold capitalize tracking-[-2.16px] !text-indigo-a700 md:text-[48px] md:tracking-[1.16px]"
                        >
                            Boost Revenue
                        </Heading>
                    </Li>
                    <Li itemHeight={height}>
                    <Heading
                            size="headinglg2"
                            as="h2"
                            className="text-center !font-schibstedgrotesk text-[40px] font-semibold capitalize tracking-[-2.16px] !text-indigo-a700 md:text-[48px] md:tracking-[1.16px]"
                        >
                            Enhance Admissions
                        </Heading>
                    </Li>
                    <Li itemHeight={height}>
                    <Heading
                            size="headinglg2"
                            as="h2"
                            className="text-center !font-schibstedgrotesk text-[40px] font-semibold capitalize tracking-[-2.16px] !text-indigo-a700 md:text-[48px] md:tracking-[1.16px]"
                        >
                            Optimize Operations
                        </Heading>
                    </Li>
                </Ul>
            </Div>
        </WordCarouselContainer>
    );
};

export default HeroTitle;